import { render, staticRenderFns } from "./ExternalSelect.vue?vue&type=template&id=4b165274&"
import script from "./ExternalSelect.vue?vue&type=script&lang=js&"
export * from "./ExternalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports